import CryptoJS from 'crypto-js'
import Website from '@/config/website'
export const loadStyle = url => {
  const link = document.createElement('link');
  link.type = 'text/css';
  link.rel = 'stylesheet';
  link.href = url;
  const head = document.getElementsByTagName('head')[0];
  head.appendChild(link);
};

export const isURL = s => {
  return /^http[s]?:\/\/.*/.test(s)
}

export const encryptPassword = password => {
  // 加密
  return CryptoJS.HmacSHA256(password, Website.clientSecret).toString(CryptoJS.enc.Hex);
}
